import { CustomerGroupBuilder } from '@symphony-solo/domain/customer-groups/src';
import { PaymentDto, TenderType } from '@symphony-solo/domain/payments/src';
import { TransactionDto, TransactionLineProductDto, TransactionLineTenderDto, TransactionTaxDto } from '../dtos';
import { TransactionType } from '../enums';
import { TransactionLineTenderBuilder } from './transaction-line-tender.builder';

export class TransactionBuilder {
  private transaction: TransactionDto;

  constructor() {
    this.transaction = new TransactionDto();
    this.transaction.products = new Array<TransactionLineProductDto>();
    this.transaction.taxes = new Array<TransactionTaxDto>();
    this.transaction.tenders = new Array<TransactionLineTenderDto>();
  }

  public setTraining(training: boolean): TransactionBuilder {
    this.transaction.training = training;
    return this;
  }

  public setTransactionID(transactionID: number): TransactionBuilder {
    this.transaction.transactionID = transactionID;
    return this;
  }

  public setTakeAway(takeAway: boolean): TransactionBuilder {
    this.transaction.takeAway = takeAway;
    return this;
  }

  public setTransactionType(type: TransactionType): TransactionBuilder {
    this.transaction.transactionType = type;
    return this;
  }

  public setCustomerGroup(id: number, name: string): TransactionBuilder {
    const customerGroup = new CustomerGroupBuilder()
      .setId(id)
      .setName(name)
      .build();
    this.transaction.customerGroup = customerGroup;
    return this;
  }

  public setTransactionProducts(transactionLineProducts: TransactionLineProductDto[]): TransactionBuilder {
    this.transaction.products = transactionLineProducts;
    return this;
  }

  public addTaxes(taxes: TransactionTaxDto[]): TransactionBuilder {
    this.transaction.taxes = taxes;
    return this;
  }

  public addTransactionLineTenders(paymentMethod: PaymentDto, totalPrice: number, wasDeleted: boolean): TransactionBuilder {
    if (wasDeleted) {
      //  in case of removing the transaction send it with no payments
      return this;
    }
    const transactLineTenderBuilder = new TransactionLineTenderBuilder()
      .setTenderType(TenderType.Cash)
      .setTenderedPayment(paymentMethod.id, paymentMethod.name)
      .setTenderedAmount(totalPrice)
      .setChangePayment(paymentMethod.id, paymentMethod.name)
      .setChangeAmount(0)
      .build();
    this.transaction.tenders.push(transactLineTenderBuilder);
    return this;
  }

  public setNetTotal(netTotal: number): TransactionBuilder {
    this.transaction.netTotal = netTotal;
    return this;
  }

  public setTaxTotal(taxTotal: number): TransactionBuilder {
    this.transaction.taxTotal = taxTotal;
    return this;
  }

  public setGrossTotal(grossTotal: number): TransactionBuilder {
    this.transaction.grossTotal = grossTotal;
    return this;
  }

  public build(): TransactionDto {
    return this.transaction;
  }
}
